import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IComponentOptions, IController, ILocationService, IModule, IPromise, IScope, ITimeoutService} from "angular";
import {StateService} from "@uirouter/angularjs";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {gettextCatalog} from "angular-gettext";
import {OppgaveRessurs} from "felles/tjenester/ressurser/OppgaveRessurs";
import {fraJson} from "felles/stoettefunk/json";
import {escKey_event} from "web/direktiver/escKey";
import {Evalueringstipdspunkt, ModelloppdateringTjeneste} from "../../../../tjenester/ModelloppdateringTjeneste";
import {erIkkeNil, erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {grupperFunksjon} from "felles-ng2/støttefunksjoner/map";

const css = require('./oppgaverFilter.scss');
type OppgaveAggreatModellMedMine =  l.OppgaveAggreatModell & {
    mineOppgaver: number;
};
export function registrerOppgaverFilterKomponent(angular: IModule) {
    angular
      .component('wmOppgaverFilter', oppgaverFilterKomponentDef())
}

export function oppgaverFilterKomponentDef(): IComponentOptions {
    return {
        bindings: {
            utfoerSoek: "&",
            initCallback: "&"
        },
        controller: OppgaverFilterKontroller.forInjisering(),
        template: require('./oppgaverFilter.html'),
        transclude: true
    };
}

export class OppgaverFilterKontroller implements IController {
    static forInjisering() {
        return [
            regNavn.ng.$scope,
            regNavn.ng.$location,
            regNavn.ng.ui.$state,
            regNavn.ng.$timeout,
            OppgaveRessurs.regNavn,
            Kontekst.regNavn,
            regNavn.gettext.gettextCatalog,
            ModelloppdateringTjeneste.regNavn,
            OppgaverFilterKontroller
        ]
    }

    constructor(private $scope: IScope,
                private $location: ILocationService,
                private $state: StateService,
                private $timeout: ITimeoutService,
                private oppgaveRessurs: OppgaveRessurs,
                private kontekst: Kontekst,
                private gettextCatalog: gettextCatalog,
                private modelloppdatering: ModelloppdateringTjeneste) {
    }

    $onInit(): void {
        this.lyttTilEscKeypress();
        this.lyttTilOppgaveendringer();

        var spekFraUrl = this.lesSpesifikasjonFraUrl();
        this.initialiserModell(spekFraUrl);
        this.oppdaterAlleIngenGrupperValgtFlagg();
        this.oppdaterAggregater();

        this.initCallback({kontroller: this});

        //kjør søk dersom spek er angitt via url
        if (spekFraUrl.spekFraUrlOk()) this.finnOppgaver();
        else {
            this.viserFilterSkjema = true;
            this.visTips = true;
        }
    }

    utfoerSoek: (args: { spesifikasjon: l.FinnOppgaverSpesifikasjon }) => IPromise<l.OppgaveModell[]>; //satt via bindings
    initCallback: Function; //settes via bindings

    modell: {
        grupper: { gruppe: l.EnkelGruppeModell; valgt: boolean }[];
        ingenGrupperValgt: boolean;
        alleGrupperValgt: boolean;
        statuser: { tittel: string; type: l.OppgavestatusKriterie; noekkel: string; valgt: boolean; }[];
        ansvarlige: AnsvarligModell[];
        ansvarligUtvalg: 'alle' | 'mine' | 'valgte';
        valgteAnsvarlige: AnsvarligModell[];
    };
    sisteSpesifikasjon: l.FinnOppgaverSpesifikasjon = null;
 
    oppgaveAggregater: OppgaveAggreatModellMedMine = null;

    visTips = false;
    viserFilterSkjema = false;
    filterbeskrivelse = "";


    /// tittel på submit-knapp oppgavesøkskjema
    stdSoekKnappTekst = this.gettextCatalog.getString('Vis oppgaver');
    soekKnappTekst = this.gettextCatalog.getString('Vis oppgaver');

    toggleFilterSkjema() {
        this.setFilterSkjemaVises(!this.viserFilterSkjema);
    }

    skjulFilterSkjema() {
        this.setFilterSkjemaVises(false);
    }

    togleAlleGrupper() {
        const endreTilValgt = !this.modell.alleGrupperValgt;
        this.modell.grupper.forEach(g => g.valgt = endreTilValgt);
        this.oppdaterAlleIngenGrupperValgtFlagg();
        this.oppdaterAggregater();
        this.oppdaterAnsvarligeBasertPåValgteGrupper();
    }

    oppdaterAlleIngenGrupperValgtFlagg() {
        this.modell.alleGrupperValgt = this.modell.grupper.every(g => g.valgt);
        this.modell.ingenGrupperValgt = this.modell.grupper.every(g => !g.valgt);
    }

    gruppeValgEndret() {
        this.oppdaterAlleIngenGrupperValgtFlagg();
        this.oppdaterAggregater();
        this.oppdaterAnsvarligeBasertPåValgteGrupper();
    }

    oppdaterAggregater() {
        this.soekKnappTekst = erIkkeNil(this.sisteSpesifikasjon) && this.spesifikasjonEndretSidenSisteSoek() ?
          /// tittel på submit-knapp oppgavesøkskjema mens submit behandles
          this.gettextCatalog.getString("Oppdater visning") : this.stdSoekKnappTekst;

        this.oppgaveRessurs.oppgaveAggregater(this.spesifikasjon()).$promise
          .then(esResultat => this.populerOppgaveAggregater(esResultat));
    }

    finnOppgaver() {
        this.soekKnappTekst = this.gettextCatalog.getString("Henter oppgaver...");
        this.sisteSpesifikasjon = this.spesifikasjon();

        this.utfoerSoek({spesifikasjon: this.sisteSpesifikasjon})
          .then((oppgaver: l.OppgaveModell[]) => {
              this.soekKnappTekst = this.stdSoekKnappTekst;
              this.visTips = oppgaver.length == 0;
          }).catch(e => this.soekKnappTekst = this.stdSoekKnappTekst);

        //sørg for at søket blir reflektert i url og dermed legger seg inn i nav-historikk
        this.skrivSpesifikasjonTilUrl();

        this.oppdaterFilterbeskrivelse();
    }

    spesifikasjonEndretSidenSisteSoek() {
        if (erNil(this.sisteSpesifikasjon)) return true;
        const spesifikasjon = this.spesifikasjon();
        return !_.isEqual(this.sisteSpesifikasjon.grupper, spesifikasjon.grupper) ||
          !_.isEqual(this.sisteSpesifikasjon.ansvarlige, spesifikasjon.ansvarlige) ||
          !_.isEqual(this.sisteSpesifikasjon.statuser, spesifikasjon.statuser);
    }

    antallOppgaverTilknyttetAnsvarlig(ansvarlig: { medlemIder: string[] }) {
        if (!this.oppgaveAggregater) return 0;

        return ansvarlig.medlemIder.reduce((total, medlemId) => {
            // Vi bruker `|| 0` i tilfelle en ID i listen ikke finnes i antallPerMedlem-mappen
            return total + (this.oppgaveAggregater.ansvarlig.antallPerMedlem[medlemId] || 0);
        }, 0);
    }

    antallOppgaverMedStatus(status: l.OppgavestatusKriterie): number {
        if (!this.oppgaveAggregater) return 0;
        switch (status) {
            case l.OppgavestatusKriterie.ikke_forfalt:
                return this.oppgaveAggregater.status.antallIkkeForfalt;
            case l.OppgavestatusKriterie.utfoert:
                return this.oppgaveAggregater.status.antallUtført;
            case l.OppgavestatusKriterie.ikke_utfoert:
                console.log('antallOppgaverMedStatus: ikke_utfoert ikke implementert');
                return -1;
            case l.OppgavestatusKriterie.uten_frist:
                return this.oppgaveAggregater.status.antallUtenFrist;
            case l.OppgavestatusKriterie.forfalt:
                return this.oppgaveAggregater.status.antallForfalt;
            default:
                console.log('Ukjent status:', status);
                return -1;
        }
    }

    // hjelpemetoder

    private lyttTilEscKeypress() {
        this.$scope.$on(escKey_event, () => this.setFilterSkjemaVises(false));
    }

    private lyttTilOppgaveendringer() {
        // Legger foreløpig til en liten timeout for å sørge for at søkeindeksen har hatt tid til å oppdatere seg, ellers kanskje aggregater gå i stå.
        this.modelloppdatering.vedOppdatertOppgave(() => true, this.$scope, () => this.$timeout(() => this.oppdaterAggregater(), 1500), Evalueringstipdspunkt.sent);
        this.modelloppdatering.vedNyOppgave(() => true, this.$scope, () => this.$timeout(() => this.oppdaterAggregater(), 1500), Evalueringstipdspunkt.sent);
        this.modelloppdatering.vedSlettetOppgave(() => true, this.$scope, () => this.$timeout(() => this.oppdaterAggregater(), 1500), Evalueringstipdspunkt.sent);
    }

    private setFilterSkjemaVises(vises: boolean) {
        this.viserFilterSkjema = vises;
    }

    private skrivSpesifikasjonTilUrl() {
        let spesifikasjon: OppgaveFilterUrlSpesifikasjon = <OppgaveFilterUrlSpesifikasjon>_.assign(this.spesifikasjon(), {
            ansvarligUtvalg: this.modell.ansvarligUtvalg,
            ansvarlige: <string[]>_(this.modell.valgteAnsvarlige).map('epost').value()
        });
        this.kontekst.oppdaterIkkePersistenteBrukervalg({oppgaveFilter: spesifikasjon});
        this.$location.search("q", angular.toJson(spesifikasjon))
    }

    private lesSpesifikasjonFraUrl() {
        let spek: OppgaveFilterUrlSpesifikasjon = fraJson(this.$state.params["q"]);
        if (!_.isObject(spek))
            spek = _.cloneDeep(this.kontekst.ikkePersistenteBrukervalg().oppgaveFilter);
        let safeSpek = <any>_.defaults(spek, {grupper: [], statuser: [], ansvarligUtvalg: null, ansvarlige: []});
        return {
            erGruppeValgt: (gruppe: l.GruppeModell) => _.isEmpty(safeSpek.grupper) || _(safeSpek.grupper).includes(gruppe.id),
            erStatusValgt: (status: l.OppgavestatusKriterie) => !_.isEmpty(safeSpek.statuser) && _(safeSpek.statuser).includes(status),
            ansvarligUtvalg: () => safeSpek.ansvarligUtvalg || "alle",
            valgteAnsvarlige: () => _(this.somAnsvarligModeller(this.kontekst.autentiserteGruppersMedlemmer())).filter(ansvarlig => _(safeSpek.ansvarlige).includes(ansvarlig.epost)).value(),
            harValgtStatuser: () => !_.isEmpty(safeSpek.statuser),
            spekFraUrlOk: () => _.isObject(spek)
        }
    }

    private initialiserModell(spekFraUrl) {
        this.modell = {
            grupper: _(this.kontekst.autentiserteGrupper()).map(gruppe => {
                return {gruppe: gruppe, valgt: spekFraUrl.erGruppeValgt(gruppe)}
            }).value(),
            alleGrupperValgt: false,
            ingenGrupperValgt: false,
            ansvarlige: [], //settes senere
            ansvarligUtvalg: spekFraUrl.ansvarligUtvalg(),
            valgteAnsvarlige: spekFraUrl.valgteAnsvarlige(),
            //merk at vi foreløpig ikke har eksponert l.OppgavestatusKriterie.ikke_utfoert
            statuser: [
                {
                    tittel: this.gettextCatalog.getString("Forfalt"),
                    type: l.OppgavestatusKriterie.forfalt,
                    noekkel: "forfalt",
                    valgt: spekFraUrl.harValgtStatuser() ? spekFraUrl.erStatusValgt(l.OppgavestatusKriterie.forfalt) : true
                },
                {
                    tittel: this.gettextCatalog.getString("Ikke forfalt"),
                    type: l.OppgavestatusKriterie.ikke_forfalt,
                    noekkel: "ikke_forfalt",
                    valgt: spekFraUrl.harValgtStatuser() ? spekFraUrl.erStatusValgt(l.OppgavestatusKriterie.ikke_forfalt) : true
                },
                {
                    tittel: this.gettextCatalog.getString("Utført"),
                    type: l.OppgavestatusKriterie.utfoert,
                    noekkel: "utfoert",
                    valgt: spekFraUrl.harValgtStatuser() ? spekFraUrl.erStatusValgt(l.OppgavestatusKriterie.utfoert) : false
                },
                {
                    tittel: this.gettextCatalog.getString("Uten frist"),
                    type: l.OppgavestatusKriterie.uten_frist,
                    noekkel: "uten_frist",
                    valgt: spekFraUrl.harValgtStatuser() ? spekFraUrl.erStatusValgt(l.OppgavestatusKriterie.uten_frist) : true
                },
            ]
        };

        this.oppdaterAnsvarligeBasertPåValgteGrupper();
    }

    private beregnAnsvarligeBasertPåValgteGrupper():AnsvarligModell[] {
        const valgteGrupper = this.modell.grupper.filter(g => g.valgt).map(g => g.gruppe.id);
        const medlemmerIValgteGrupper = (this.modell.ingenGrupperValgt || this.modell.alleGrupperValgt) ?
          this.kontekst.autentiserteGruppersMedlemmer() :
          this.kontekst.autentiserteGruppersMedlemmer().filter(medlem => valgteGrupper.includes(medlem.gruppeId));
        return this.somAnsvarligModeller(medlemmerIValgteGrupper);
    }

    private somAnsvarligModeller(medlemmer: l.GruppeMedlemListeModell[]): AnsvarligModell[] {
        return Array.from(medlemmer
          .reduce(grupperFunksjon(medlem => medlem.epost), new Map<string, l.GruppeMedlemListeModell[]>).values())
          .map((medlemmerPerEpost: l.GruppeMedlemListeModell[]) => ({
              epost: medlemmerPerEpost[0].epost,
              navn: medlemmerPerEpost[0].navn,
              medlemIder: medlemmerPerEpost.map(medlem => medlem.id),
              foersteMedlemRepresentasjon: medlemmerPerEpost[0]
          }));
    }

    private oppdaterAnsvarligeBasertPåValgteGrupper() {
        this.modell.ansvarlige = this.beregnAnsvarligeBasertPåValgteGrupper();
    }

    private spesifikasjon(): l.FinnOppgaverSpesifikasjon {
        let spesifikasjon = {
            grupper: _(this.modell.grupper)
              .filter(gruppe => gruppe.valgt)
              .map(gruppe => gruppe.gruppe.id).value(),
            statuser: _(this.modell.statuser)
              .filter(status => status.valgt)
              .map(status => status.type)
              .value(),
            ansvarlige: <string[]>_(this.modell.valgteAnsvarlige).map('medlemIder').flatten().value()
        };

        if (this.modell.ansvarligUtvalg == 'alle')
            spesifikasjon.ansvarlige = [];

        if (this.modell.ansvarligUtvalg == 'mine')
            spesifikasjon.ansvarlige = _(this.kontekst.medlemRepresentasjoner()).map(medlem => medlem.id).value();

        return spesifikasjon;
    }

    private oppdaterFilterbeskrivelse() {
        const filtrertPåGruppe = this.sisteSpesifikasjon.grupper.length != this.modell.grupper.length;
        const filtrertPåAnsvarlig = !_.isEmpty(this.sisteSpesifikasjon.ansvarlige);
        const filtrertPåStatus = !_.isEmpty(this.sisteSpesifikasjon.statuser);

        if (!filtrertPåGruppe && !filtrertPåAnsvarlig && !filtrertPåStatus)
          /// beskrivelse av filter på oppgavesiden som vises når filter ikke er ekspandert, når filter ikke begrenser oppgavelisten
            this.filterbeskrivelse = this.gettextCatalog.getString('Viser alle oppgaver');
        else {
            const fragmenter = [];
            if (filtrertPåGruppe) {
                const valgteGrupper = this.modell.grupper.filter(gruppe => gruppe.valgt).map(gruppe => gruppe.gruppe);
                if (valgteGrupper.length > 6)
                  /// beskrivelse av filter på oppgavesiden som vises når filter ikke er ekspandert, når filter inneholder gruppebegrensning og subsett > 6
                    fragmenter.push(this.gettextCatalog.getString('tilknyttet {{antallValgt}} av {{totaltAntall}} tilgjengelige grupper', {
                        antallValgt: valgteGrupper.length,
                        totaltAntall: this.modell.grupper.length
                    }));

                else
                  /// beskrivelse av filter på oppgavesiden som vises når filter ikke er ekspandert, når filter inneholder gruppebegrensning
                    fragmenter.push(this.gettextCatalog.getPlural(valgteGrupper.length,
                      'tilknyttet gruppen {{grupper}}',
                      'tilknyttet gruppene {{grupper}}', {
                          grupper: valgteGrupper.map(gruppe => `${gruppe.organisasjonsnavn} (${gruppe.tittel})`).join(', ')
                      }));
            }
            if (filtrertPåAnsvarlig) {
                const ansvarlige = this.modell.ansvarligUtvalg == 'mine' ?
                  _([this.kontekst.autentisertBruker().navnEllerEpost]) :
                  _(this.modell.valgteAnsvarlige).map('navn');
                /// beskrivelse av filter på oppgavesiden som vises når filter ikke er ekspandert, når filter inneholder ansvarligbegrensning
                fragmenter.push(this.gettextCatalog.getPlural(ansvarlige.size(), 'tildelt {{ansvarlige}}', 'tildelt {{ansvarlige}}', {ansvarlige: ansvarlige.join(', ')}))
            }
            if (filtrertPåStatus) {
                const statuser = _(this.modell.statuser)
                  .filter(status => status.valgt)
                  .map(status => status.tittel);
                /// beskrivelse av filter på oppgavesiden som vises når filter ikke er ekspandert, når filter inneholder statusbegrensning
                fragmenter.push(this.gettextCatalog.getPlural(statuser.size(), 'med frist {{statuser}}', 'med frist som er {{statuser}}', {statuser: statuser.join(', ')}))
            }
            /// beskrivelse av filter på oppgavesiden som vises når filter ikke er ekspandert, når filter inneholder begrensninger
            this.filterbeskrivelse = this.gettextCatalog.getString('Viser oppgaver {{filter}}', {filter: _(fragmenter).join(', ')});
        }
    }
    private populerOppgaveAggregater(esResultat: l.OppgaveAggreatModell) {

       this.oppgaveAggregater =  {
        ...esResultat,
          mineOppgaver: this.kontekst.medlemRepresentasjoner().reduce((total, medlem) => {
              // Vi bruker `|| 0` i tilfelle en ID i listen ikke finnes i antallPerMedlem-mappen
              return total + (esResultat.ansvarlig.antallPerMedlem[medlem.id] || 0);
          }, 0),
        };
    }

}

interface AnsvarligModell {
    navn: string;
    epost: string; //epost fungerer som unik identifikator på tvers av medlemmer som kun er invitert og medlemmer som er tilknyttet en bruker
    foersteMedlemRepresentasjon: l.GruppeMedlemListeModell;
    medlemIder: string[]
}

export interface OppgaveFilterUrlSpesifikasjon extends l.FinnOppgaverSpesifikasjon {
    /** merk at FinnOppgaverSpesifikasjon.ansvarlige er definert som medlemId, mens vi her definerer ansvarlige som epostadresser */
    ansvarlige: string[];
    ansvarligUtvalg: 'alle' | 'mine' | 'valgte';
}
